import React from 'react';

import IconType from 'types/Icon';

export const CommentIcon: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none">
		<path
			d="M4.00195 3C2.90889 3 2.00195 3.90694 2.00195 5V17C2.00195 18.0931 2.90889 19 4.00195 19H18.002L22.002 23L21.9902 4.99805C21.9902 3.90498 21.0821 3 19.9902 3H4.00195ZM4.00195 5H19.9902L19.998 18.168L18.8301 17H4.00195V5ZM7 8V10H17V8H7ZM7 12V14H14V12H7Z"
			fill={color}
		/>
	</svg>
);
